var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"5.12641","y1":"16.102","x2":"15.733","y2":"5.49539","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("line",{"x1":"15.7331","y1":"16.4556","x2":"5.1265","y2":"5.84902","stroke":"currentColor","strokeWidth":"1.5","key":1})]);
}

Close.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Close;

Close.default = Close;
